<div [ngTemplateOutlet]="selected?.content"></div>
@if (!hideStepsIndicator) {
  <div [class.hide]="hideWrapper" [ngClass]="['content ', goStepperClass]" class="steps-wrapper">
    @for (step of steps; track step; let i = $index) {
      <span class="step" [ngClass]="{'is-active': isSelected(i), 'hide': step.hideIndicator}"></span>
    }
  </div>
}
